export enum TYPE_DNI {
    CEDULA    = "CEDULA",
    JURICA    = "JURICA",
    DIMEX     = "DIMEX",
    PASAPORTE = "PASAPORTE",
}
